/**
 * @deprecated please use @website/ui instead
 */
export * from "./table";
/**
 * @deprecated please use @website/ui instead
 */
export * from "./table.types";
